export const CHECKOUT_URL = 'https://track-field-coach-ready.impultienda.ar/checkout'

const PRODUCT_NAME = 'Track & Field Coach Ready — Complete 7-Volume Coaching System'
const PRODUCT_VALUE = 27

type PixelWindow = Window & {
  fbq?: (event: string, name: string, data: Record<string, string | number>) => void
}

export function trackCheckout(): void {
  if (typeof window === 'undefined') return
  const pixelWindow = window as PixelWindow
  pixelWindow.fbq?.('track', 'InitiateCheckout', {
    content_name: PRODUCT_NAME,
    value: PRODUCT_VALUE,
    currency: 'USD',
  })
}
